import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function SlideClosing() {
  return <div className="h-full w-full bg-[#1B4F72] text-white flex flex-col items-center justify-center p-12 relative overflow-hidden" data-id="element-249">
      {/* Background decoration - angular gradient */}
      <div className="absolute bottom-0 left-0 w-full h-1/2 bg-gradient-to-t from-[#5B8FAF]/10 to-transparent pointer-events-none" data-id="element-250" />

      {/* Diagonal accent elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#5B8FAF]/10 pointer-events-none" style={{
      clipPath: 'polygon(100% 0, 100% 100%, 0 100%)'
    }} data-id="element-251" />
      <div className="absolute bottom-0 left-0 w-1/4 h-1/2 bg-[#7CB9D8]/5 pointer-events-none" style={{
      clipPath: 'polygon(0 100%, 100% 100%, 0 0)'
    }} data-id="element-252" />

      <motion.div className="z-10 text-center max-w-3xl" initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8
    }} data-id="element-253">
        <h2 className="text-4xl md:text-6xl font-bold mb-8 leading-tight" data-id="element-254">
          Ready to activate your next congress?
        </h2>

        <motion.div className="inline-block mb-12" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} data-id="element-255">
          <div className="text-2xl font-light tracking-widest uppercase border-b border-[#7CB9D8] pb-2 mb-2" data-id="element-256">
            Snakker™
          </div>
        </motion.div>

        <motion.button className="group flex items-center gap-3 mx-auto text-xl font-medium text-[#7CB9D8] hover:text-white transition-colors duration-300" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} whileHover={{
        x: 5
      }} data-id="element-257">
          Let's talk
          <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-258" />
        </motion.button>
      </motion.div>

      <motion.div className="absolute bottom-12 right-12 opacity-50" initial={{
      opacity: 0
    }} animate={{
      opacity: 0.5
    }} transition={{
      delay: 1
    }} data-id="element-259">
        <span className="text-lg font-bold tracking-wider" data-id="element-260">NUBEQA®</span>
      </motion.div>
    </div>;
}